import React from "react";

import { ZeosButton } from "../../Shared/ZeosButton";
import { ZeosModal } from "../../Shared/ZeosModal";

interface IProps {
  isOpen: boolean;
  partnerName: string;
  isSubmitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const IntroductionConsentModal = ({
  isOpen,
  partnerName,
  isSubmitting,
  onClose,
  onConfirm,
}: IProps) => {
  return (
    <ZeosModal isOpen={isOpen} onClose={onClose}>
      <div className="pr-6">
        <h3 className="text-xl font-bold text-zeos-black mb-3">
          Request Introduction
        </h3>
        <p className="text-zeos-black mb-6">
          Share my building summary and contact info with{" "}
          <strong>{partnerName}</strong>? ZEOS may receive a referral fee if you
          engage this partner.
        </p>
        <div className="flex justify-end gap-3">
          <ZeosButton
            label="Cancel"
            type="button"
            mode="prev"
            onPress={onClose}
            isDisabled={isSubmitting}
          />
          <ZeosButton
            label={isSubmitting ? "Sending..." : "Confirm & Share"}
            type="button"
            mode="action"
            onPress={onConfirm}
            isDisabled={isSubmitting}
          />
        </div>
      </div>
    </ZeosModal>
  );
};
